/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";

const Dropdown = ({ options, selected, onSelect }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={ref} className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-left shadow-sm text-sm text-gray-800 focus:outline-none"
      >
        {selected || "Select"}
        <span className="float-right text-gray-400">⌄</span>
      </button>

      {open && (
        <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto">
          {options.map((option) => (
            <li
              key={option}
              onClick={() => {
                onSelect(option);
                setOpen(false);
              }}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const TimeDropdown = ({ label, value, onChange }) => {
  const [hour = "12", minute = "00", period = "AM"] = value
    ? value.match(/(\d{1,2}):(\d{2})\s?(AM|PM)/i)?.slice(1) || []
    : [];

  const hours = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );
  const periods = ["AM", "PM"];

  const updateTime = (h, m, p) => {
    const formatted = `${h}:${m} ${p}`;
    onChange(formatted);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="flex space-x-3">
        <div className="w-1/3">
          <Dropdown
            options={hours}
            selected={hour}
            onSelect={(h) => updateTime(h, minute, period)}
          />
        </div>
        <div className="w-1/3">
          <Dropdown
            options={minutes}
            selected={minute}
            onSelect={(m) => updateTime(hour, m, period)}
          />
        </div>
        <div className="w-1/3">
          <Dropdown
            options={periods}
            selected={period}
            onSelect={(p) => updateTime(hour, minute, p)}
          />
        </div>
      </div>
    </div>
  );
};

export default TimeDropdown;
